/**
 * Calcula o CRC16 CCITT (polinômio 0x1021)
 * Implementação baseada no padrão BR Code (PIX)
 */
export const calculateCRC16 = (str) => {
  let crc = 0xFFFF;
  const bytes = new TextEncoder().encode(str);

  for (let i = 0; i < bytes.length; i++) {
    crc ^= (bytes[i] << 8);
    
    for (let j = 0; j < 8; j++) {
      if ((crc & 0x8000) !== 0) {
        crc = ((crc << 1) ^ 0x1021) & 0xFFFF;
      } else {
        crc = (crc << 1) & 0xFFFF;
      }
    }
  }

  return crc.toString(16).toUpperCase().padStart(4, '0');
};

/**
 * Gera o payload completo do PIX conforme padrão EMV/BR Code
 */
export const generatePixPayload = (data) => {
  const { chave, valor, beneficiario, cidade } = data;

  console.log('🔧 Gerando PIX com:', { chave, valor, beneficiario, cidade });

  // Limpa e formata strings (apenas letras, números e espaços)
  const cleanString = (str, maxLen = 25) => {
    return str
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^A-Z0-9 ]/g, '')
      .trim()
      .substring(0, maxLen);
  };

  const chavePix = chave.trim();
  const valorStr = parseFloat(valor).toFixed(2);
  const nomeBenef = cleanString(beneficiario, 25);
  const cidadeStr = cleanString(cidade, 15);

  console.log('🔧 Valores formatados:', { chavePix, valorStr, nomeBenef, cidadeStr });

  // Cria campo EMV: ID(2) + Tamanho(2) + Valor
  const emv = (id, value) => {
    const len = value.length.toString().padStart(2, '0');
    return `${id}${len}${value}`;
  };

  // Monta Merchant Account Information (ID 26) - SEM txId
  const merchantInfo = emv('00', 'br.gov.bcb.pix') + emv('01', chavePix);

  // Monta o payload base
  let payload = '';
  payload += emv('00', '01');                    // Payload Format Indicator
  payload += emv('26', merchantInfo);            // Merchant Account Information
  payload += emv('52', '0000');                  // Merchant Category Code
  payload += emv('53', '986');                   // Transaction Currency (BRL)
  payload += emv('54', valorStr);                // Transaction Amount
  payload += emv('58', 'BR');                    // Country Code
  payload += emv('59', nomeBenef);               // Merchant Name
  payload += emv('60', cidadeStr);               // Merchant City

  // Adiciona CRC16
  payload += '6304';  // ID 63, tamanho 04
  const crc = calculateCRC16(payload);
  payload += crc;

  console.log('✅ Payload PIX gerado:', payload);
  console.log('📏 Tamanho:', payload.length);
  console.log('🔐 CRC16:', crc);

  return payload;
};
